module.exports = __webpack_public_path__ + "static/img/zz1.06f3bfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/zz1.jpg
// module id = xDFY
// module chunks = 1